import React from 'react';
import { removeExtraSpaces } from '../../scripts/helpers';
var IconsHolder = function IconsHolder(_ref) {
  var propSize = _ref.size,
    propVariant = _ref.variant,
    className = _ref.className,
    classProp = _ref["class"],
    propShape = _ref.shape,
    propIcon = _ref.icon,
    step = _ref.step;
  var classBasename = 'icons-holder';
  var stepValue = step || '';
  var size = stepValue ? '' : propSize ? "".concat(classBasename, "-").concat(propSize) : "".concat(classBasename, "-md");
  var variant = propVariant ? "".concat(classBasename, "-").concat(propVariant) : ' ';
  var cl = classProp || className || '';
  var shape = stepValue ? "".concat(classBasename, "-round") : propShape ? "".concat(classBasename, "-").concat(propShape) : ' ';
  var icon = propIcon || '';
  var fullClass = removeExtraSpaces("".concat(classBasename, " ").concat(cl, " ").concat(stepValue ? 'content-holder' : '', " ").concat(icon, " ").concat(size, " ").concat(shape, " ").concat(variant));
  return React.createElement("span", {
    className: fullClass
  }, stepValue);
};
export default IconsHolder;